import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauMettreEnEchecAction from '../actions/BordereauMettreEnEchecAction';
import BaseBordereauState from './BaseBordereauState';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BordereauForceEtatAcquittementAction from '../actions/BordereauForceEtatAcquittementAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';

class BordereauTeletransmissionState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.TELETRANSMIS;
    this.state = BordereauStateType.TELETRANSMIS;
    this.color = '#9A5555';
    this.libelle = 'Télétransmission';
  }

  getBordereauActions(
    _bordereau: BordereauWithState,
    userRole: UserRole,
  ): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
      new BordereauDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new BordereauModifierAction({ isSuperUser: true }),
        new BordereauMettreEnEchecAction({ isSuperUser: true }),
        new BordereauForceEtatAcquittementAction({ isSuperUser: true, isAcquittement: true }),
        new BordereauForceEtatAcquittementAction({ isSuperUser: true, isAcquittement: false }),
      ] : [],
    ];
  }

  getMouvementActions(userRole : UserRole): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
      new MouvementModifierAction({ isReadonly: true }),
      new MouvementDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new MouvementModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }
}

export default BordereauTeletransmissionState;
